export default "__VITE_ASSET__DbuwcICt__"